/* Esse objeto reúne constantes para códigos de permissões de recursos e rotas. O objetivo é ter uma estrutura
semelhante ao desktop para manter a compatibilidade de permissões durante a migração desktop-web */

export const PERMS = {
  /* MÓDULO ADM APPCLI */
  ADMAPPCLI_MENU_PASSENGER_ANALYTICS: 36007,
  ADMAPPCLI_MENU_PASSENGER_PASSAGEIRO: 36006,

  /* MÓDULO ADM PARTNER */
  // cadastro
  ADMPARTNER_MENU_CADASTRO_AGENDA_ESCALA: 44001,
  ADMPARTNER_MENU_CADASTRO_FORNECEDOR: 44004,
  ADMPARTNER_MENU_CADASTRO_USUARIO: 44003,
  ADMPARTNER_MENU_CADASTRO_USUARIO_PARTNER: 44002,

  // configurações
  ADMPARTNER_MENU_CONFIGURACOES_GERAL: 36002,

  /* MÓDULO ESTOQUE */
  // cadastro
  ESTOQUE_MENU_CADASTRO_CIDADE: 23010,
  ESTOQUE_MENU_CADASTRO_FICHA_TECNICA: 23037,
  ESTOQUE_MENU_CADASTRO_FORNECEDOR: 23008,
  ESTOQUE_MENU_CADASTRO_FUNCIONARIO: 23009,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_BOX: 23030,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_CORREDOR: 23027,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_ESTANTE: 23028,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_LOCALIZACAO_INTERNA_PRATELEIRA: 23029,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_CLASSIFICACAO: 23004,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_GRUPO: 23002,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_MERCADORIA: 23005,
  ESTOQUE_MENU_CADASTRO_MERCADORIA_SUBGRUPO: 23003,
  ESTOQUE_MENU_CADASTRO_MODELO_DOCUMENTO_FISCAL: 23031,
  ESTOQUE_MENU_CADASTRO_REQUISICAO_PREDEFINIDA: 23006,
  ESTOQUE_MENU_CADASTRO_SETOR: 23007,
  ESTOQUE_MENU_CADASTRO_UNIDADE: 23001,
  ESTOQUE_MENU_CADASTRO_USUARIO: 23011,

  // estoque
  ESTOQUE_CANCELA_REQUISICAO: 23046,
  ESTOQUE_CONFIRMA_REQUISICAO: 23044,
  ESTOQUE_DEVOLVE_REQUISICAO: 23045,
  ESTOQUE_MENU_ESTOQUE_ACERTO: 23015,
  ESTOQUE_MENU_ESTOQUE_AGRUPAMENTO_NF_GERACAO_CONTA_PAGAR: 23026,
  ESTOQUE_MENU_ESTOQUE_ENTRADA_MERCADORIA: 23012,
  ESTOQUE_MENU_ESTOQUE_FECHAMENTO_MENSAL: 23016,
  ESTOQUE_MENU_ESTOQUE_REQUISICAO: 23013,
  ESTOQUE_MENU_ESTOQUE_TRANSFERENCIA: 23014,

  // relatórios
  ESTOQUE_MENU_RELATORIOS_CONTROLE_VALIDADE: 23019, // código duplicado estoque
  ESTOQUE_MENU_RELATORIOS_ENTRADA_DEVOLUCAO: 23017,
  ESTOQUE_MENU_RELATORIOS_ESTOQUE_MINIMO_ALMOXARIFADO: 23042,
  ESTOQUE_MENU_RELATORIOS_ETIQUETA_CODIGO_BARRA_GRADE_MERCADORIA: 23038,
  ESTOQUE_MENU_RELATORIOS_ETIQUETA_MERCADORIA: 23032,
  ESTOQUE_MENU_RELATORIOS_FICHA_MERCADORIA: 23025,
  ESTOQUE_MENU_RELATORIOS_INVENTARIO: 23022,
  ESTOQUE_MENU_RELATORIOS_LISTAGEM_MERCADORIA: 23040,
  ESTOQUE_MENU_RELATORIOS_LOG: 23033,
  ESTOQUE_MENU_RELATORIOS_MOVIMENTACAO_MERCADORIA: 23019, // código duplicado estoque
  ESTOQUE_MENU_RELATORIOS_MOVIMENTO_PRODUTO_VENDA: 23039,
  ESTOQUE_MENU_RELATORIOS_REQUISICAO: 23018,
  ESTOQUE_MENU_RELATORIOS_SALDO_MERCADORIA: 23021,
  ESTOQUE_MENU_RELATORIOS_SALDO_MERCADORIA_DATA: 23036,
  ESTOQUE_MENU_RELATORIOS_SALDO_SETOR: 23041,
  ESTOQUE_MENU_RELATORIOS_SALDO_SETOR_DATA: 23043,
  ESTOQUE_MENU_RELATORIOS_ULTIMA_COMPRA: 23020,

  // opções
  ESTOQUE_MENU_OPCOES_COPIA_SEGURANCA: 23023,
  ESTOQUE_MENU_OPCOES_MODELO_RELATORIO: 23034,
  ESTOQUE_MENU_OPCOES_REORGANIZA_ESTOQUE: 23035,

  // configurações
  ESTOQUE_MENU_CONFIGURACOES_GERAL: 23024,

  /* MÓDULO FINANÇAS */
  FINANCAS_MENU_CADASTRO_BANCO: 22005,
  FINANCAS_MENU_CADASTRO_CONTA_CORRENTE: 22004,
  FINANCAS_MENU_CADASTRO_FERIADO: 22043,
  FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO: 22001,
  FINANCAS_MENU_CADASTRO_SETOR: 22006,
  FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO: 22002,
  FINANCAS_MENU_CADASTRO_TRANSACAO: 22058,
  FINANCAS_MENU_FECHAMENTO_FINANCEIRO_EXECUTAR: 22044,

  /* MÓDULO FRONT */
  FRONT_ALTERA_CLIENTE_SERVICO_OS: 12059, // altera o cliente do serviço - permissão interna
  FRONT_MENU_CADASTRO_CLIENTE_CLIENTE: 12009,
  FRONT_MENU_CADASTRO_SERVICO_CATEGORIA: 12002,
  FRONT_MENU_CADASTRO_SERVICO_MOTIVO_CANCELAMENTO: 12138,
  FRONT_MENU_CADASTRO_SERVICO_SERVICO: 12003,
  FRONT_MENU_CADASTRO_USUARIO: 12016,
  FRONT_MENU_CADASTRO_VEICULO_TIPO: 12045,
  FRONT_MENU_CADASTRO_VENDEDOR: 12082,
  FRONT_MENU_PROCEDIMENTOS_ORDEM_SERVICO: 12018,

  /* MÓDULO FROTAS */
  // cadastro
  FROTAS_ATUALIZAR_SALDO_ESTOQUE_TANQUE_COMBUSTIVEL: 26035,
  FROTAS_INATIVAR_VEICULO: 26055,
  FROTAS_MENU_CADASTRO_ABASTECIMENTO_BOMBA_INTERNA: 26013,
  FROTAS_MENU_CADASTRO_ABASTECIMENTO_CATEGORIA_COMBUSTIVEL: 26015,
  FROTAS_MENU_CADASTRO_ABASTECIMENTO_COMBUSTIVEL: 26014,
  FROTAS_MENU_CADASTRO_ABASTECIMENTO_TANQUE_INTERNO: 26012,
  FROTAS_MENU_CADASTRO_CIDADE: 26018,
  FROTAS_MENU_CADASTRO_FORNECEDOR: 26016,
  FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_CLIENTE: 26064,
  FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_LINHA: 26063,
  FROTAS_MENU_CADASTRO_FRETAMENTO_CONTINUO_LINHA_CLIENTE: 26065,
  FROTAS_MENU_CADASTRO_FUNCIONARIO: 26017,
  FROTAS_MENU_CADASTRO_MANUTENCAO_GRUPO_SERVICO: 26005,
  FROTAS_MENU_CADASTRO_MANUTENCAO_INSTRUCAO_PREVENTIVA: 26043,
  FROTAS_MENU_CADASTRO_MANUTENCAO_MOTIVO: 26041,
  FROTAS_MENU_CADASTRO_MANUTENCAO_SERVICO: 26006,
  FROTAS_MENU_CADASTRO_PNEU_CONDICAO: 26009,
  FROTAS_MENU_CADASTRO_PNEU_FABRICANTE: 26007,
  FROTAS_MENU_CADASTRO_PNEU_MEDIDA: 26010,
  FROTAS_MENU_CADASTRO_PNEU_MODELO: 26008,
  FROTAS_MENU_CADASTRO_PNEU_PNEU: 26011,
  FROTAS_MENU_CADASTRO_USUARIO: 26019,
  FROTAS_MENU_CADASTRO_VEICULO_MARCA: 26003,
  FROTAS_MENU_CADASTRO_VEICULO_MODELO: 26004,
  FROTAS_MENU_CADASTRO_VEICULO_OPCIONAL: 26075,
  FROTAS_MENU_CADASTRO_VEICULO_TIPO: 26001,
  FROTAS_MENU_CADASTRO_VEICULO_VEICULO: 26002,
  FROTAS_VISUALIZAR_ABA_RH_CADASTRO_FUNCIONARIO: 26033,

  // procedimentos
  FROTAS_ALTERAR_ABASTECIMENTO: 26044,
  FROTAS_CANCELAR_REQUISICAO: 26074,
  FROTAS_CONFIRMAR_REQUISICAO: 26072,
  FROTAS_CONTROLAR_OCORRENCIA: 26059,
  FROTAS_DEVOLVER_REQUISICAO: 26073,
  FROTAS_IGNORAR_CONTROLE_RIGIDO_ABASTECIMENTO: 26057,
  FROTAS_INSERIR_ABASTECIMENTO_HODOMETRO_INFERIOR_ATUAL: 26061, // código duplicado frotas
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_ACERTO_ESTOQUE_COMBUSTIVEL: 26037,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_AJUSTE: 26056,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_CTF: 26054,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_LANCAR: 26022,
  FROTAS_MENU_PROCEDIMENTOS_ABASTECIMENTO_NF_COMBUSTIVEL: 26036,
  FROTAS_MENU_PROCEDIMENTOS_AGRUPAR_GERAR_CONTA_PAGAR_MAO_OBRA_EXTERNA: 26058,
  FROTAS_MENU_PROCEDIMENTOS_ALERTA_EMAIL_OS_PREVENTIVA: 26049,
  FROTAS_MENU_PROCEDIMENTOS_DOCUMENTO_FUNCIONARIO: 26053,
  FROTAS_MENU_PROCEDIMENTOS_DOCUMENTO_VEICULO: 26052,
  FROTAS_MENU_PROCEDIMENTOS_FRETAMENTO_CONTINUO: 26062,
  FROTAS_MENU_PROCEDIMENTOS_GERACAO_OS_PREVENTIVA: 26045,
  FROTAS_MENU_PROCEDIMENTOS_MAPA_VEICULO: 26023,
  FROTAS_MENU_PROCEDIMENTOS_MULTA: 26061, // código duplicado frotas
  FROTAS_MENU_PROCEDIMENTOS_ORDEM_SERVICO: 26021,
  FROTAS_MENU_PROCEDIMENTOS_PARCELAMENTO_PAGAR: 26069,
  FROTAS_MENU_PROCEDIMENTOS_PNEU_PARADA_MOVIMENTACAO: 26020,
  FROTAS_MENU_PROCEDIMENTOS_REQUISICAO: 26051,
  FROTAS_REABRIR_OS_ENCERRADA: 26048,

  // relatórios
  FROTAS_MENU_RELATORIOS_ABASTECIMENTO_COMPARATIVO_MES: 26046,
  FROTAS_MENU_RELATORIOS_ABASTECIMENTO_FICHA_MERCADORIA: 26042,
  FROTAS_MENU_RELATORIOS_ABASTECIMENTO_LISTAGEM: 26034,
  FROTAS_MENU_RELATORIOS_APURACAO_VEICULO: 26068,
  FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_PERIODO: 26066,
  FROTAS_MENU_RELATORIOS_FRETAMENTO_CONTINUO_PLANEJADO_REALIZADO_MES: 26067,
  FROTAS_MENU_RELATORIOS_LOG: 26030,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_EXTRATO_CUSTO_VEICULO: 26076,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_LISTAGEM: 26038,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_ORDEM_SERVICO: 26039,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_ABERTO: 26024,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_DETALHADA: 26027,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_GERAL: 26026,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_PREVENTIVA_VENCER: 26025,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_REALIZADA: 26040,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_SERVICO_CANCELADO: 26050,
  FROTAS_MENU_RELATORIOS_MANUTENCAO_SERVICO_REALIZADO: 26047,
  FROTAS_MENU_RELATORIOS_OCORRENCIA: 26060,
  FROTAS_MENU_RELATORIOS_PNEU_MOVIMENTACAO: 26070,
  FROTAS_MENU_RELATORIOS_PNEU_MOVIMENTACAO_VEICULO: 26071,

  // opções
  FROTAS_MENU_OPCOES_COPIA_SEGURANCA: 26029,
  FROTAS_MENU_OPCOES_MODELO_RELATORIO: 26031,

  // configurações
  FROTAS_MENU_CONFIGURACOES_GERAL: 26032,

  /* MÓDULO GERENCIAL */
  GERENCIAL_MENU_ADMINISTRATIVO: 40004,
  GERENCIAL_MENU_FINANCEIRO: 40003,
  GERENCIAL_MENU_OPERACIONAL: 40002,
  GERENCIAL_MENU_PRODUCAO: 40001
};